import _ from 'lodash';
import { Document } from 'mongoose';
import { fallbackLanguage } from '../constants';
import { ICountry } from '../schemas/country';
import { LanguageKeys } from '../schemas/localized-text';
import { IServiceLocation } from '../schemas/serviceLocation';

export function toSingleLangLocation(
  location: IServiceLocation & { country?: ICountry },
  lang: LanguageKeys,
): IServiceLocation {
  if (typeof ((location as unknown) as Document).toObject === 'function') {
    throw new Error('location object can not be a mongoose document, it has to be a POJO');
  }

  if (location && location.country && _.isObject(location.country.names)) {
    const { country } = location;
    _.set(country, 'names', country.names[lang] || country.names[fallbackLanguage]);
  }
  return location;
}
